import { json, type LoaderFunctionArgs, type MetaFunction } from '@remix-run/node'
import { useTranslation } from 'react-i18next'
import { CalEmbed } from '#app/ui/components/custom/cal-embed.tsx'
import { Pill } from '#app/ui/components/custom/pill.tsx'
import { Container } from '#app/ui/components/layout/container.js'
import { H1 } from '#app/ui/components/typography/h1.tsx'
import { Lead } from '#app/ui/components/typography/lead.tsx'
import { appName } from '#app/utils/constants.ts'
import i18next from '#app/utils/locale.server.ts'
import { getRequestInfo, socialMeta } from '#app/utils/seo.ts'

export const handle = { i18n: 'call' }

export async function loader({ request }: LoaderFunctionArgs) {
	const t = await i18next.getFixedT(request, 'call')
	return json({
		title: t('meta.title', { appName }),
		description: t('meta.description'),
	})
}

export const meta: MetaFunction<typeof loader> = ({ data, matches }) =>
	socialMeta({
		title: data?.title ?? `Book a call | ${appName}`,
		description:
			data?.description ??
			'Thirty minutes, free. I map where your revenue leaks and what to build first.',
		requestInfo: getRequestInfo(matches),
	})

export default function CallRoute() {
	const { t } = useTranslation('call')

	return (
		<Container>
			<div className="py-fluid-17">
				<div className="max-w-2xl">
					<Pill>{t('pill')}</Pill>
					<H1 className="mt-fluid-10 text-balance text-fluid-4xl normal-case">
						{t('title')}
					</H1>
					<Lead className="mt-fluid-9 text-muted-600">{t('lead')}</Lead>
				</div>

				<div className="mt-fluid-16 overflow-hidden rounded-2xl border border-hairline bg-surface p-2 sm:p-4">
					<CalEmbed />
				</div>
			</div>
		</Container>
	)
}
